import React from 'react';
import styled from 'styled-components';

import { Bus } from '@lt/components/icons-react/userflow';
import SkeletonLine from '../Skeleton/SkeletonLine';
import SkeletonSlash from '../Skeleton/SkeletonSlash';
import SkeletonCircle from '../Skeleton/SkeletonCircle';

import Icon from '../../../../components/Icon';

const baseCls = 'checkout-packageinfo-skeleton';

const StyledBus = styled(Bus)`
  width: 23px;
  color: #4d4d4d;
`;

const PackageInfoSkeleton = () => (
  <div className={`${baseCls}__skeleton`}>
    <div className="flex flex-column">
      <div className={`${baseCls}__row`}>
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14, marginLeft: 10 }} />

        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />
        <SkeletonSlash style={{ width: 14 }} />

        <SkeletonSlash style={{ width: 14, marginLeft: 10 }} />
        <SkeletonSlash style={{ width: 14 }} />
      </div>

      <div
        style={{ marginTop: 10, marginBottom: 10 }}
        className={`${baseCls}__row`}
      >
        <div className={`${baseCls}__icon`}>
          <SkeletonCircle style={{ width: 30, height: 30 }} />
        </div>

        <div
          style={{ height: '100%' }}
          className="flex flex-column flex-space-around"
        >
          <SkeletonLine style={{ width: 182 }} />
          <SkeletonLine style={{ width: 182 }} />
        </div>
      </div>

      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__icon`}>
          <Icon type="food" />
        </div>
        <SkeletonLine style={{ width: 122 }} />
      </div>

      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__icon`}>
          <Icon type="plane" />
        </div>
        <SkeletonLine style={{ width: 182 }} />
      </div>

      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__icon`}>
          <StyledBus />
        </div>
        <div className="flex flex-column">
          <SkeletonLine style={{ width: 212 }} />
        </div>
      </div>

      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__icon`} />
        <SkeletonLine style={{ width: 182 }} />
      </div>

      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__icon`}>
          <Icon type="garranty" />
        </div>
        <SkeletonLine style={{ width: 162 }} />
      </div>
    </div>
  </div>
);

export default PackageInfoSkeleton;
